import { ServerService } from './server.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CreateGameModel } from '../model/createGameModel';
import { QuestionModel } from '../model/questionModel';
import { ScoreModel } from '../model/scoreModel';
import { QuestionPointModel } from '../model/questionPointModel';
import { UtilityService } from './utility.service';
import * as firebase from 'firebase';

@Injectable({
    providedIn: 'root'
  })
export class GameService {
    private _idGame: string;
    private _idTurn: string;
    private _idTournament: string;
    private _yr: string;
    private _src: string;

    secondGamer:string='Anonimo';
    uidFirstGamer:string=undefined;
    firstGamer:string=undefined;
    isPlayer:boolean=true;
    private _idQuestion: string;
    private _difficulty: string;
    private _gameType: string;
 
    isTournamentSubscribed: boolean = false;

    gameAudio = new Audio();

    constructor(
        private serverSrv: ServerService,
        private _utilSrv: UtilityService
        ) {

    }

    createGameBotFunction(): Observable<CreateGameModel>{
       return this.serverSrv.createGameBotFunction(this.idTournament, this._utilSrv.difficulty).pipe(map( res => {
          this.idGame = res.matchId;
          return res;
        }))
    }

    questionPointFunction(): Observable<QuestionPointModel>{
     // tslint:disable-next-line: max-line-length
     return this.serverSrv.questionPointFunction(this._idQuestion, this._idGame, this._utilSrv.difficulty, this.idTournament, this.idTurn).pipe(map( res => {
         return res;
        }))
     }

     getQuestionFunction(): Observable<QuestionModel>{
        // tslint:disable-next-line: max-line-length
        return this.serverSrv.getQuestionFunction(this._idGame, this._utilSrv.difficulty, this.idTournament, this.idTurn, this.serverSrv.yearValue, this.serverSrv.sourceValue).pipe(map( res => {
            this.yr = this.serverSrv.yearValue;
            this.src = this.serverSrv.sourceValue;
            this._idQuestion = res.question.id;
           return res;
         }))
     }

     getScoreFunction(): Observable<ScoreModel>{
        return this.serverSrv.getScoreFunction(this._idGame, this._utilSrv.difficulty, this.idTournament, this.idTurn).pipe(map( res => {
           return res
         }))
     }

     playAudioCurrentGame() {
        this.getGameAudioFromStorage()
        .then(response => {
            this.gameAudio.src = response;
            this.gameAudio.load();
            this.gameAudio.play();
            this.gameAudio.loop = true;
        })
        .catch(error => {
            console.log('error', error);
        });
     }

     getGameAudioFromStorage(): Promise<any>{
         return firebase.storage().ref('assets').child('game_music.mp3').getDownloadURL();
         /*
         return firebase.storage().ref('assets').listAll().then(last => {
             for (let i = 0; i < last.items.length; i++) {
                 if (i === (last.items.length - 1)) {
                     return last.items[i].getDownloadURL();
                 }
                 console.log(last.items[i].getMetadata());
             }
         });
         */

     }


     setAnswerFunction(idAnswer: string): Observable<any>{
        return this.serverSrv.setAnswerFunction(this._idQuestion, idAnswer, this._idGame, this._utilSrv.difficulty, this.idTournament, this.idTurn).pipe(map( res => {
           return res;
         }))
     }

    get idGame() {
        return this._idGame;
    }

    set idGame(idGame: string) {
        this._idGame = idGame;
    }


    get idTurn() {
        return this._idTurn;
    }

    set idTurn(idTurn: string) {
        this._idTurn = idTurn;
    }


    get idTournament() {
        return this._idTournament;
    }

    set idTournament(idTournament: string) {
        this._idTournament = idTournament;
    }

    get yr() {
        return this._yr;
    }

    set yr(yr: string) {
        this._yr = yr;
    }

    get src() {
        return this._src;
    }

    set src(src: string) {
        this._src = src;
    }

    get difficulty() {
        return this._difficulty;
    }

    set difficulty(difficulty: string) {
        this._difficulty = difficulty;
    }

    get gameType() {
        return this._gameType;
    }

    set gameType(gameType: string) {
        this._gameType = gameType;
    }

}